import {Component, TemplateRef} from '@angular/core';
import {ToastService} from '../../../services/toast-service';



@Component({
    selector: 'app-toasts',
    template: `
    @for (toast of toastService.toasts; track toast) {
      <ngb-toast style="margin-top: 35px; padding: 25px"
        [class]="toast.classname"
        [autohide]=true
        [delay]="toast.delay || 1000"
        (hide)="toastService.remove(toast)"
        >
        @if (isTemplate(toast)) {
          <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
        } @else {
          {{ toast.textOrTpl }}
        }
      </ngb-toast>
    }
    `,
    host: { '[class.ngb-toasts]': 'true' },
    standalone: false
})
export class ToastContainerComponent {
  constructor(public toastService: ToastService) {}

  isTemplate(toast) { return toast.textOrTpl instanceof TemplateRef; }
}
